import {Button, Dialog, DialogActions, DialogContent, DialogTitle} from "@mui/material";
import {ISubtitles} from "./LocalizedSubtitles";
import {useContext, useEffect, useState} from "react";
import {FirebaseContext} from "../firebase/FirebaseProvider";
import {LocalizedLanguages} from "./Localization";
import {EditEnglishSubtitles} from "./EditEnglishSubtitles";
import {ProjectDetails} from "../../redux/types/firebase";
import {selectProjects} from "../../redux/selectors/firebase";
import {connect} from "react-redux";
import {EditLocalizedSubtitles} from "./EditLocalizedSubtitles";
import { storeKeyName } from "./subtitleUtils";

const defaultSubtitles: ISubtitles = {
    modified: 0,
    cues: [],
    languages: {}
}
interface IUpdateSubtitleDialog {
    blockName: string
    language: string
    onClose: () => void
    project: string
    projects: {[project:string]: ProjectDetails}
    subtitles: ISubtitles
}
function UpdateSubtitleDialog({blockName, onClose, project, projects, language, subtitles}: IUpdateSubtitleDialog) {
    const [dirty, setDirty] = useState(false);
    const [working, setWorking] = useState<ISubtitles>(defaultSubtitles);
    const {set} = useContext(FirebaseContext);
    const handleUpdateSubtitleClick = () => {
        if (language === "english") {
            working.modified = Date.now();
        } else {
            working.languages[language].modified = Date.now();
        }
        set(`subtitles/${project}/${storeKeyName(blockName)}`, working).catch(console.error).then(() => {
            setDirty(false);
            onClose();
        });
    }
    const handleSubtitlesChange = (update: ISubtitles) => {
        setWorking(update);
    }

    useEffect(() => {
        if (subtitles?.modified) {
            setWorking(JSON.parse(JSON.stringify(subtitles)));
        } else {
            setWorking(JSON.parse(JSON.stringify(defaultSubtitles)));
        }
    }, [subtitles]);
    useEffect(() => {
        setDirty(JSON.stringify(working) !== JSON.stringify(subtitles));
    }, [subtitles, working])
    return (
        <Dialog fullWidth open={true} onClose={onClose}>
            <DialogTitle>
                Edit {LocalizedLanguages[language]} subtitles
                {working.modified !== 0 && `(last modified (${new Date(working.modified).toLocaleString()})`}
            </DialogTitle>
            <DialogContent dividers>
                {language === "english" ?
                    <EditEnglishSubtitles blockName={blockName} onChange={handleSubtitlesChange}
                                          project={projects[project]} subtitles={working}/> :
                    <EditLocalizedSubtitles blockName={blockName} language={language} onChange={handleSubtitlesChange}
                                            project={projects[project]} subtitles={working}/>}
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} variant="contained">Cancel</Button>
                <Button disabled={! dirty && language === "english"} onClick={handleUpdateSubtitleClick}
                        variant="contained">Update</Button>
            </DialogActions>
        </Dialog>
    );
}
const mapStateToProps = (store: never) => ({
    projects: selectProjects(store),
});

const connected = connect(mapStateToProps, {
})(UpdateSubtitleDialog);
export {connected as UpdateSubtitleDialog};